import { Http } from '@/repositories/HttpCommon'
import { template, templateSettings } from '@/utils/lodash'
import { getGlobalConfig } from '@/utils/globalConfig'

function resolveEndpoint (endpointName, params) {
  templateSettings.interpolate = /{{([\s\S]+?)}}/g

  const endpointConfig = getGlobalConfig('ENDPOINTS')
  const renderer = template(endpointConfig[endpointName])
  return renderer(params)
}

function httpPost (endpointName, { params, data, config }) {
  const endpoint = resolveEndpoint(endpointName, params)
  return Http.post(endpoint, data, config)
}

function httpGet (endpointName, { params, config }) {
  const endpoint = resolveEndpoint(endpointName, params)
  return Http.get(endpoint, config)
}

export {
  httpGet,
  httpPost
}
